import { createContext, useContext, useState } from "react";
import axiosInstance from "../api/api";

const RCNContext = createContext();

export const RCNProvider = ({ children }) => {
  const [RCN, setRCN] = useState(null);
  const [merchantId, setMerchantId] = useState(null);
  const [coupons, setCoupons] = useState([]);
  const [isApiLoaded, setIsApiLoaded] = useState(false);
  const [configurationDetails, setConfigurationDetails] = useState({});

  const fetchMerchantId = async (locationUid) => {
    try {
      const response = await axiosInstance.get(`/koupons/getMerchantDetails?uId=${locationUid}`);
      const mId = response?.data?.id;

      if (!mId)
        return console.error("Merchant ID not found in response:", response?.data);

      setMerchantId(mId);
    } catch (error) {
      console.error("Failed to fetch Merchant ID:", error);
    }
  };

  const initializeRCNs = async (locationId) => {
    try {
      if (!locationId) return;
      await fetchMerchantId(locationId);
      const response = await axiosInstance.get(`/MkonnektPlatform/entity/getRcnByLocationDetail?locationUid=${locationId}`);

      setIsApiLoaded(true);

      if (response.data) {
        setRCN(response.data);
        localStorage.setItem("RCN", response.data);
        await fetchCoupons(response.data);
      }
    } catch (error) {
      setIsApiLoaded(true);
      console.error("Failed to initialize RCN data:", error);
    }
  };

  const fetchCoupons = async (rcn) => {
    try {
      const response = await axiosInstance.get(`/koupons/getConfigurationDetails?rcn=${rcn}&source=backoffice`);
      const couponData = response.data?.kouponsMap?.coupons || [];
      setCoupons(couponData);
      setConfigurationDetails(response.data);
    } catch (error) {
      console.error("Failed to fetch coupons:", error);
    }
  };

  const refreshCoupons = async () => {
    if (RCN) await fetchCoupons(RCN);
  };

  return (
    <RCNContext.Provider
      value={{
        RCN,
        setRCN,
        merchantId,
        setMerchantId,
        coupons,
        isApiLoaded,
        initializeRCNs,
        configurationDetails,
        setConfigurationDetails,
        refreshCoupons,
      }}
    >
      {children}
    </RCNContext.Provider>
  );
};

export const useRCN = () => useContext(RCNContext);
